import axios from "axios";
import Trigger from "../../validations/es6/plugins/Trigger";
import Bootstrap from "../../validations/es6/plugins/Bootstrap";
import SubmitButton from "../../validations/es6/plugins/SubmitButton";
import Declarative from "../../validations/es6/plugins/Declarative";
import Sequence from "../../validations/es6/plugins/Sequence";
import { getCookie } from "../../jwt/_helpers/cookie";
import { getValidationMessage } from "../../utils/i18nHelper";

import linkLandingPagesValidationEN from "../../locales/en/linkLandingPagesValidation";
import linkLandingPagesValidationDE from "../../locales/de/linkLandingPagesValidation";
import linkLandingPagesValidationES from "../../locales/es/linkLandingPagesValidation";
import linkLandingPagesValidationFR from "../../locales/fr/linkLandingPagesValidation";
import linkLandingPagesValidationIT from "../../locales/it/linkLandingPagesValidation";
import linkLandingPagesValidationHR from "../../locales/hr/linkLandingPagesValidation";
import linkLandingPagesValidationNL from "../../locales/nl/linkLandingPagesValidation";
import linkLandingPagesValidationPT from "../../locales/pt/linkLandingPagesValidation";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const validUrlRegex = /^(?:https?|http):\/\/(?:[^\s\/]+\.)?[^\s\/]+\.[^\s\/]+(?:\/[^\/\s]*)*$/;

const platformValidUrls = {
  "instagram": "instagram.com",
  "facebook": "facebook.com",
  "twitter": "twitter.com",
  "linkedin": "linkedin.com",
  "tiktok": "tiktok.com",
  "youtube": "youtube.com",
  "other": "",
};

export const validationMessagesUpdate = {
  en: linkLandingPagesValidationEN.update,
  de: linkLandingPagesValidationDE.update,
  es: linkLandingPagesValidationES.update,
  fr: linkLandingPagesValidationFR.update,
  it: linkLandingPagesValidationIT.update,
  hr: linkLandingPagesValidationHR.update,
  nl: linkLandingPagesValidationNL.update,
  pt: linkLandingPagesValidationPT.update,
};

const createValidationOptions = (lang) => {
  return {
    fields: {
      title: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessagesUpdate, 'title', 'required', lang)
          },
          stringLength: {
            min: 0,
            max: 32,
            message: getValidationMessage(validationMessagesUpdate, 'title', 'length', lang)
          },
        }
      },
      short_description: {
        validators: {
          stringLength: {
            min: 0,
            max: 80,
            message: getValidationMessage(validationMessagesUpdate, 'short_description', 'length', lang)
          },
        }
      },
      back_url: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessagesUpdate, 'back_url', 'required', lang)
          },
          stringLength: {
            min: 0,
            max: 10,
            message: getValidationMessage(validationMessagesUpdate, 'back_url', 'length', lang),
          },
          promise: {
            message: getValidationMessage(validationMessagesUpdate, 'back_url', 'unique', lang),
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                let backUrlInitial = document.getElementById("updateLinkLandingPage").querySelector('[name="back_url_initial"]').value;
                if(input.value !== "" && input.value !== backUrlInitial) {
                  const token = getCookie("token");
                  const requestBody = {
                    back_url: input.value,
                  };
                  axios({
                    method: "POST",
                    mode: 'cors',
                    url: `${API_URL}link-landingpages/validate-back-url/`,
                    data: requestBody,
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "x-api-key": X_API_KEY,
                    }
                  }).then(function(response) {
                    if (response.status === 200) {
                      const valid = response.data.valid;
                      const message = response.data.status;
  
                      valid ? resolve({ valid: true, message: getValidationMessage(validationMessagesUpdate, 'back_url', 'available', lang) }) : resolve({ valid: false, message: message });
                    } else {
                      reject({valid: false, message: getValidationMessage(validationMessagesUpdate, 'back_url', 'invalid', lang)});
                    }
                  });
                }
                else {
                  resolve({ valid: true, message: getValidationMessage(validationMessagesUpdate, 'back_url', 'available', lang) })
                }
              });
            }
          },
        }
      },
      logo: {
        validators: {
          promise: {
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                const files = input.element.files;
  
                const img = new Image();
                img.addEventListener("load", function() {
                  const w = this.width;
                  const h = this.height;
                  resolve({
                    valid: w >= 500 && h >= 500 && w===h,
                    message: getValidationMessage(validationMessagesUpdate, 'logo', 'dimensions', lang),
                    meta: {
                      source: img.src,
                      width: w,
                      height: h
                    }
                  });
                });
                img.addEventListener("error", function() {
                  reject({
                    valid: false,
                    message: getValidationMessage(validationMessagesUpdate, 'logo', 'choose', lang)
                  });
                });
  
                const reader = new FileReader();
                reader.readAsDataURL(files[0]);
                reader.addEventListener("loadend", function(e) {
                  img.src = e.target.result;
                });
              });
            }
          },
          file: {
            extension: "jpeg,jpg,png",
            type: "image/jpeg,image/png",
            maxSize: 2048576,
            message: getValidationMessage(validationMessagesUpdate, 'logo', 'file', lang)
          }
        }
      },
      background_image: {
        validators: {
          promise: {
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                const files = input.element.files;
  
                const img = new Image();
                img.addEventListener("load", function() {
                  const w = this.width;
                  const h = this.height;
                  resolve({
                    valid: w >= 1000 && h >= 1000 && w===h,
                    message: getValidationMessage(validationMessagesUpdate, 'background_image', 'dimensions', lang),
                    meta: {
                      source: img.src,
                      width: w,
                      height: h
                    }
                  });
                });
                img.addEventListener("error", function() {
                  reject({
                    valid: false,
                    message: getValidationMessage(validationMessagesUpdate, 'background_image', 'choose', lang)
                  });
                });
  
                const reader = new FileReader();
                reader.readAsDataURL(files[0]);
                reader.addEventListener("loadend", function(e) {
                  img.src = e.target.result;
                });
              });
            }
          },
          file: {
            extension: "jpeg,jpg,png",
            type: "image/jpeg,image/png",
            maxSize: 5121440,
            message: getValidationMessage(validationMessagesUpdate, 'background_image', 'file', lang)
          }
        }
      },
      "social_link[0].destination_url_facebook": {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_facebook', 'required', lang)
          },
          regexp: {
            regexp: validUrlRegex,
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_facebook', 'regexp', lang),
          },
          promise: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_facebook', 'invalid', lang),
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                if(input.value !== "") {
                  let destinationUrl = input.value;
                  let validPlatformUrl = platformValidUrls["facebook"];
                  let socialUrlValid = destinationUrl.includes(validPlatformUrl);
                  if(destinationUrl !== "other" && !socialUrlValid) {
                    resolve({ valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_facebook', 'invalid', lang)});
                  } else {
                    resolve({valid: true, message: ""});
                  }
                }
                else {
                  reject({valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_facebook', 'invalid', lang)});
                }
              })
            }
          },
        }
      },
      "social_link[0].destination_url_instagram": {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_instagram', 'required', lang)
          },
          regexp: {
            regexp: validUrlRegex,
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_instagram', 'regexp', lang),
          },
          promise: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_instagram', 'invalid', lang),
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                if(input.value !== "") {
                  let destinationUrl = input.value;
                  let validPlatformUrl = platformValidUrls["instagram"];
                  let socialUrlValid = destinationUrl.includes(validPlatformUrl);
                  if(destinationUrl !== "other" && !socialUrlValid) {
                    resolve({ valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_instagram', 'invalid', lang)});
                  } else {
                    resolve({valid: true, message: ""});
                  }
                }
                else {
                  reject({valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_instagram', 'invalid', lang)});
                }
              })
            }
          },
        }
      },
      "social_link[0].destination_url_twitter": {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_twitter', 'required', lang)
          },
          regexp: {
            regexp: validUrlRegex,
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_twitter', 'regexp', lang),
          },
          promise: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_twitter', 'invalid', lang),
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                if(input.value !== "") {
                  let destinationUrl = input.value;
                  let validPlatformUrl = platformValidUrls["twitter"];
                  let socialUrlValid = destinationUrl.includes(validPlatformUrl);
                  if(destinationUrl !== "other" && !socialUrlValid) {
                    resolve({ valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_twitter', 'invalid', lang)});
                  } else {
                    resolve({valid: true, message: ""});
                  }
                }
                else {
                  reject({valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_twitter', 'invalid', lang)});
                }
              })
            }
          },
        }
      },
      "social_link[0].destination_url_youtube": {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_youtube', 'required', lang)
          },
          regexp: {
            regexp: validUrlRegex,
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_youtube', 'regexp', lang),
          },
          promise: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_youtube', 'invalid', lang),
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                if(input.value !== "") {
                  let destinationUrl = input.value;
                  let validPlatformUrl = platformValidUrls["youtube"];
                  let socialUrlValid = destinationUrl.includes(validPlatformUrl);
                  if(destinationUrl !== "other" && !socialUrlValid) {
                    resolve({ valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_youtube', 'invalid', lang)});
                  } else {
                    resolve({valid: true, message: ""});
                  }
                }
                else {
                  reject({valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_youtube', 'invalid', lang)});
                }
              })
            }
          },
        }
      },
      "social_link[0].destination_url_tiktok": {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_tiktok', 'required', lang)
          },
          regexp: {
            regexp: validUrlRegex,
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_tiktok', 'regexp', lang),
          },
          promise: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_tiktok', 'invalid', lang),
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                if(input.value !== "") {
                  let destinationUrl = input.value;
                  let validPlatformUrl = platformValidUrls["tiktok"];
                  let socialUrlValid = destinationUrl.includes(validPlatformUrl);
                  if(destinationUrl !== "other" && !socialUrlValid) {
                    resolve({ valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_tiktok', 'invalid', lang)});
                  } else {
                    resolve({valid: true, message: ""});
                  }
                }
                else {
                  reject({valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_tiktok', 'invalid', lang)});
                }
              })
            }
          },
        }
      },
      "social_link[0].destination_url_linkedin": {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_linkedin', 'required', lang)
          },
          regexp: {
            regexp: validUrlRegex,
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_linkedin', 'regexp', lang),
          },
          promise: {
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_linkedin', 'invalid', lang),
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                if(input.value !== "") {
                  let destinationUrl = input.value;
                  let validPlatformUrl = platformValidUrls["linkedin"];
                  let socialUrlValid = destinationUrl.includes(validPlatformUrl);
                  if(destinationUrl !== "other" && !socialUrlValid) {
                    resolve({ valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_linkedin', 'invalid', lang)});
                  } else {
                    resolve({valid: true, message: ""});
                  }
                }
                else {
                  reject({valid: false, message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_linkedin', 'invalid', lang)});
                }
              })
            }
          },
        }
      },
      "social_link[0].destination_url_other": {
        validators: {
          regexp: {
            regexp: validUrlRegex,
            message: getValidationMessage(validationMessagesUpdate, 'social_link_destination_url_other', 'regexp', lang),
          },
        }
      },
      "featured_link[0].title": {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessagesUpdate, 'featured_link_title', 'required', lang)
          },
          stringLength: {
            min: 0,
            max: 100,
            message: getValidationMessage(validationMessagesUpdate, 'featured_link_title', 'length', lang)
          },
        }
      },
      "featured_link[0].destination_url": {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessagesUpdate, 'featured_link_destination_url', 'required', lang)
          },
          regexp: {
            regexp: validUrlRegex,
            message: getValidationMessage(validationMessagesUpdate, 'featured_link_destination_url', 'regexp', lang),
          },
        }
      },
    },
    plugins: {
      trigger: new Trigger(),
      bootstrap: new Bootstrap(),
      submitButton: new SubmitButton(),
      declarative: new Declarative({
        html5Input: true
      }),
      sequence: new Sequence({
        enabled: true
      }),
    }
  };
};

export { createValidationOptions };